"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    fill: "currentColor",
    width: "100%",
    height: "100%",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 397.37 296.36",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M146,323.78v-44H253.36q1.41-7.15,3.29-13.75H139.12a6.88,6.88,0,0,0-6.87,6.88v57.74a6.88,6.88,0,0,0,6.87,6.88H250.27q-.54-6.73-.66-13.75Z",
      transform: "translate(-101.31 -151.82)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M454,279.78v44H350.39q-.12,7-.66,13.75H460.88a6.88,6.88,0,0,0,6.87-6.88V272.91a6.88,6.88,0,0,0-6.87-6.88H343.35q1.88,6.59,3.29,13.75Z",
      transform: "translate(-101.31 -151.82)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M269.2,403.53H146v-44H253.24c-.86-4.44-1.59-9-2.15-13.75h-112a6.88,6.88,0,0,0-6.87,6.88V410.4a6.88,6.88,0,0,0,6.87,6.88h141.3A61,61,0,0,1,269.2,403.53Z",
      transform: "translate(-101.31 -151.82)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M454,359.53v44H330.8a61,61,0,0,1-11.22,13.75h141.3a6.88,6.88,0,0,0,6.87-6.88V352.66a6.88,6.88,0,0,0-6.87-6.88h-112c-.56,4.72-1.29,9.31-2.15,13.75Z",
      transform: "translate(-101.31 -151.82)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M491.81,174.42H426.44V159.74a7.94,7.94,0,0,0-7.92-7.92H365.73a7.94,7.94,0,0,0-7.92,7.92v14.68H242.19V159.74a7.94,7.94,0,0,0-7.92-7.92H181.48a7.94,7.94,0,0,0-7.92,7.92v14.68H108.19a6.88,6.88,0,0,0-6.88,6.88v260a6.88,6.88,0,0,0,6.88,6.87H491.81a6.88,6.88,0,0,0,6.88-6.87v-260A6.88,6.88,0,0,0,491.81,174.42Zm-6.87,260H115.06V188.17H484.94Z",
      transform: "translate(-101.31 -151.82)"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      points: "236.99 144.75 199.99 144.75 199.99 66.37 160.39 173.62 197.39 173.62 197.39 252 236.99 144.75"
    })]
  });
};

exports.default = Icon;